<template>
  <div v-if="link" class="resource-cta flex flex-wrap align-center">
    <div class="resource__image">
      <MediaImage :max-width="180" :media="cardMedia" :use-aspect="true" />
    </div>
    <div>
      <LinkCallToAction
        :link="link"
        :link-label="linkLabel"
        class="resource__cta-link"
        default-label="View this resource"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ResourcesCallToActionProps } from './types'

defineProps<ResourcesCallToActionProps>()
</script>

<style lang="less" scoped>
.resource-cta {
  .justify-center();
  .rounded-sm();

  background: @color-fill-pale;
  padding: @gutter-lg;
  margin: @gutter-xl 0;

  @media @tablet {
    .justify-start();
  }

  > div {
    .text-center();

    flex: 1 1 auto;
    margin-top: @gutter;

    @media @tablet {
      margin: 0 @gutter-xs 0 @gutter-lg;
    }
  }

  .resource__image {
    flex: 0 0 @180px;
    margin: 0;
  }
}
</style>
